import * as Radix from '@radix-ui/react-slider'
import { forwardRef } from 'react'

interface Props extends Radix.SliderProps {
  markers?: number
}

const Slider = forwardRef<HTMLDivElement, Props>(
  ({ markers = 0, ...props }, ref) => (
    <Radix.Root
      className="relative flex w-full touch-none select-none items-center"
      {...props}
      ref={ref}
    >
      <Radix.Track className="relative h-2 w-full grow overflow-hidden rounded-full bg-zinc-500">
        <Radix.Range className="absolute h-full bg-blue-500" />
        {markers > 0 && (
          <div className="absolute flex h-full w-full flex-row items-center justify-between gap-2 px-1">
            {Array.from({ length: markers }).map((_, idx) => (
              <div
                key={`marker-${idx}`}
                className="size-full h-[3px] w-[3px] rounded-full bg-white shadow-[0px_0px_9px_0px_#0000001F]"
              />
            ))}
          </div>
        )}
      </Radix.Track>
      <Radix.Thumb className="block h-5 w-5 rounded-full bg-white shadow-[0px_0px_9px_0px_#0000001F] outline-none" />
    </Radix.Root>
  )
)

Slider.displayName = 'Slider'

export default Slider
